import React from 'react';
import PageHeaderSection from 'app/components/misc/PageHeaderSection';
import { RichText } from 'prismic-reactjs';
import * as S from './styles';

const TermsContent = ({ doc }) => {
  const conditions = doc.terms.map((term, index) => {
    return <S.Text key={index}>{RichText.render(term.clause)}</S.Text>;
  });

  return (
    <>
      <PageHeaderSection
        title="Terms & Subscription Agreement"
        subtitle={RichText.asText(doc.version)}
      />
      <S.PageContent>{conditions}</S.PageContent>
    </>
  );
};

export default TermsContent;
